import { render, staticRenderFns } from "./TheTickePriorityTag.vue?vue&type=template&id=9ad5820c"
import script from "./TheTickePriorityTag.vue?vue&type=script&lang=js"
export * from "./TheTickePriorityTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports